import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { OverlayType } from "../../../vendor_core/core/src/server/data/ISpinData";
import { ICondition } from "../../../vendor_core/core/src/states/State";


export default class BBHasLockedCondition implements ICondition {
    public check(): boolean {
        if(SpinModel.isInFreespins()){
            return SpinModel.hasOverlay(OverlayType.Locked);
        }
    }
}